import Cookies from "js-cookie";
import { useRouter } from "next/router";

import { useTranslation } from "../../core/translation.core";
import { getDomain } from "../../core/cookies.core";
import { useQuery } from "@tanstack/react-query";
import { getAdminShop } from "../../core/retailShop.core";

export const selectCss =
  "px-3 py-2 " + //
  "rounded border border-[#CCCCCC] " +
  "text-black dark:text-her-gray dark:bg-her-backblue ";

export const profileGridCss = "grid grid-cols-1 md:grid-cols-[200px_200px] items-center";

export default function ProfileLocale() {
  const router = useRouter();
  const { t, msg } = useTranslation();

  const { data: shop } = useQuery({
    queryFn: getAdminShop,
    queryKey: ["shop"],
  });

  const localeLabels = {
    en: t(msg.setting.english),
    "zh-Hans": t(msg.setting.chineseS),
    "zh-Hant": t(msg.setting.chineseT),
  };

  function changeLocale(value: string) {
    router.push({ pathname: router.pathname, query: router.query }, router.asPath, { locale: value });
    Cookies.set("NEXT_LOCALE", value, {
      domain: getDomain(),
      expires: 9999,
      sameSite: "strict",
    });
  }

  if (!shop) return null;

  return (
    <div className={profileGridCss}>
      <h2 className="dark:text-white">{t(msg.setting.chooseLanguage)}</h2>

      <select id="select-locale" className={selectCss} onChange={(e) => changeLocale(e.target.value)} value={router.locale}>
        {shop.locales.map((locale) => (
          <option key={locale} value={locale}>
            {localeLabels[locale] || locale} {/* Display label or fallback to locale code */}
          </option>
        ))}
      </select>
    </div>
  );
}
